import { Grid, Typography, ButtonBase, Box } from "@mui/material";
import { Link } from 'react-router-dom';
import logo from "../Recursos/logo.svg";
import Email_Footer from "./Secciones/Componentes/Email_Footer";
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useResponsive } from "../Modulo_Responsive/Hooks/useResponsive";

const Footer = () => {
    const { sCell } = useResponsive();
    const links = [
        { nombre: 'Inicio', ruta: '/' },
        { nombre: 'Servicios', ruta: '/servicios/' },
        { nombre: 'Nosotros', ruta: '/sobre-mi' },
        { nombre: 'Blog', ruta: '/blogs/' },
        { nombre: 'Contacto', ruta: '/contacto/' },
    ];

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{ pt: 4, pb:2, borderTop: '1px solid #DFDFDF', mt: 8 }}
        >
            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }}>
                <Grid justifyContent="center" size={{ xs: 12, sm: 12, md: 10 }}>
                    <Grid container size={{ xs: 12 }}>
                        {/* Logo */}
                        <Grid container justifyContent="flex-start" alignItems="flex-start" size={{ xs: 12, sm: 3, md: 3 }} sx={{ pb: 4 }}>
                            <img src={logo} width="50%" height="auto" alt="Logo Martha Alvarez" itemProp="logo"/>
                        </Grid>

                        {/* Links Rápidos */}
                        <Grid container size={{ xs: 12, sm: 3, md: 3 }}>
                            <nav aria-label="Enlaces rápidos">
                                <Typography component="h4" sx={{ fontSize: 16, fontWeight: 600, mb: 2, color: '#223B59' }}>
                                    Links Rápidos:
                                </Typography>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    {links.map(link => (
                                        <li key={link.nombre} style={{ }}>
                                            <ButtonBase component={Link} to={link.ruta} sx={{ textAlign: "left" , pb:2}}>
                                                <Typography sx={{ fontFamily: 'Poppins', fontSize: 16, fontWeight: 500, color: '#223B59' }}>
                                                    {link.nombre}
                                                </Typography>
                                            </ButtonBase>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </Grid>

                        {/* Contacto con Microdatos */}
                        <Grid container direction="column" alignItems="flex-start" size={{ xs: 12, sm: 3, md: 3 }} sx={{ pt: sCell ? 2 : 0, gap: 2 }} itemScope itemType="https://schema.org/Organization">
                            <Typography component="h4" sx={{ fontSize: 16, fontWeight: 600, color: '#223B59' }}>
                                Contáctanos
                            </Typography>
                            <Grid container direction="column" gap={2}>
                                <Grid container alignItems="center" gap={1}>
                                    <Typography sx={{ color: '#223B59', fontWeight: 500 }} itemProp="telephone">313 794 6514</Typography>
                                </Grid>
                                <Grid container alignItems="center" gap={1}>
                                    <Typography sx={{ color: '#223B59', fontWeight: 500 }} itemProp="email">info@espaciocompacto.com</Typography>
                                </Grid>
                                <Grid container alignItems="center" gap={1}>
                                    <Typography sx={{ color: '#223B59', fontWeight: 500 }} itemProp="address">Cali, Colombia</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Redes Sociales */}
                        <Grid container size={{ xs: 12, sm: 3, md: 3 }} sx={{ pt: sCell ? 5 : 0 }}>
                            <Grid container justifyContent="flex-start" alignItems="flex-start" size={{ xs: 12 }} sx={{ pb: 2 }}>
                                <Box component="ul" sx={{ display: "flex", gap: 4, listStyle: "none", p: 0, m: 0 }}>
                                    <li>
                                        <ButtonBase component="a" href="https://www.instagram.com/marthaalvarez.arq" target="_blank" rel="noopener noreferrer" aria-label="Instagram Martha Alvarez">
                                            <InstagramIcon sx={{ fontSize: 45, color: '#223B59' }} />
                                        </ButtonBase>
                                    </li>
                                    <li>
                                        <ButtonBase component="a" href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook Martha Alvarez">
                                            <FacebookRoundedIcon sx={{ fontSize: 45, color: '#223B59' }} />
                                        </ButtonBase>
                                    </li>
                                    <li>
                                        <ButtonBase component="a" href="https://youtube.com/@arq.marthaalvarez" target="_blank" rel="noopener noreferrer" aria-label="YouTube Martha Alvarez">
                                            <YouTubeIcon sx={{ fontSize: 45, color: '#223B59' }} />
                                        </ButtonBase>
                                    </li>
                                </Box>
                            </Grid>
                            <Email_Footer/>
                        </Grid>

                        {/* Políticas */}
                        <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }} sx={{ pt: 4 }}>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 4, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/politica-de-privacidad/" title="Política de Privacidad">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, fontWeight: 400, color: '#223B59' }}>
                                        Política de Privacidad
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 4, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/terminos-y-condiciones/" title="Términos y Condiciones">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, fontWeight: 400, color: '#223B59' }}>
                                        Términos y Condiciones
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 4, sm: 4, md: 4 }}>
                                <ButtonBase component={Link} to="/politica-de-cookies/" title="Política de Cookies">
                                    <Typography sx={{ fontFamily: 'Poppins', fontSize: 14, fontWeight: 400, color: '#223B59' }}>
                                        Política de Cookies
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Footer;
